export function SetupTabs(context = document) {
    const tabEls = context.querySelectorAll('.js-tabs')

    if (tabEls.length) {
        import('./tabs')
            .then((m) => m.CreateTabs)
            .then((CreateTabs) => {
                Array.from(tabEls).map(CreateTabs)
            })
    }
}
